<template>
  <div id="performance-report-section-form">
    <div class="grid grid-cols-12 gap-6 mt-5">
      <div class="intro-y col-span-12 lg:col-span-6">
        <!-- BEGIN: Form Layout -->
        <div class="intro-y box p-5">

          <div class="mt-3">
            <label for="section_name_zh" class="form-label">中文名稱</label>
            <input v-model="form.section_name_zh" id="section_name_zh" type="text" class="form-control w-full" placeholder="請輸入中文名稱">
            <div v-if="'section_name_zh' in errors" class="text-danger mt-2" v-html="errors.section_name_zh"></div>
          </div>

          <div class="mt-3">
            <label for="section_name_en" class="form-label">英文名稱</label>
            <input v-model="form.section_name_en" id="section_name_en" type="text" class="form-control w-full" placeholder="請輸入英文名稱">
            <div v-if="'section_name_en' in errors" class="text-danger mt-2" v-html="errors.section_name_en"></div>
          </div>

          <div class="mt-3">
            <label for="section_index" class="form-label">目錄ID</label>
            <input v-model="form.section_index" id="section_index" type="text" class="form-control w-full" placeholder="請輸入目錄ID">
            <div v-if="'section_index' in errors" class="text-danger mt-2" v-html="errors.section_index"></div>
          </div>

          <div class="mt-3">
            <label for="display_order" class="form-label"><span class="text-danger">*</span> 顯示次序</label>
            <input v-model="form.display_order" id="display_order" type="number" class="form-control w-full" placeholder="請輸入顯示次序">
            <div v-if="'display_order' in errors" class="text-danger mt-2" v-html="errors.display_order"></div>
          </div>

          <div class="flex justify-end align-items-center mt-5">
            <router-link v-if="!loading && !finish" to="/management/performance-reports" type="button" class="btn btn-outline-secondary w-24 mr-1">取消</router-link>
            <button v-if="!loading && !finish" type="button" class="btn btn-primary w-24" @click="onSave">儲存</button>
            <span v-show="loading && !finish"><i data-loading-icon="oval" class="w-8 h-8"></i></span>
          </div>
        </div>
        <!-- END: Form Layout -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['data'],
  data() {
    return {
      mode: 'create',
      sites: [],
      form: {
        section_name_zh: null,
        section_name_en: null,
        section_index: null,
        display_order: null
      },
      errors: {},
      loading: false,
      finish: false
    }
  },
  watch: {
    data(val) {
      this.init()
    }
  },
  mounted() {
    window.tailwind.svgLoader()
    this.init()
  },
  methods: {
    init() {
      if (this.data != null) {
        this.form = this.data
        this.mode = 'update'
      }
    },
    onSave: async function() {
      this.loading = true
      this.errors = {}

      let response

      if (this.mode === 'create') {
        response = await this.createPerformanceReportSection(this.form)
      } else {
        response = await this.updatePerformanceReportSection(this.data.section_id, this.form)
      }

      if ('errors' in response.data) {
        this.errors = response.data.errors
        this.loading = false
      } else {
        let option = {
          title: (this.mode === 'create') ? '已成功新增部分' : '已成功更新部分',
          message: '請稍後，將會轉至執行報告頁面',
          type: 'success'
        }

        if (response.code === 0) {
          this.finish = true

          setTimeout(() => {
            this.$router.push('/management/performance-reports')
          }, 1000)
        } else {
          this.loading = false
          option = {
            title: (this.mode === 'create') ? '未能新增部分' : '未能更新部分',
            message: response.data.message ?? '系統錯誤，請稍後再試',
            type: 'error'
          }
        }

        this.$notify(option)
      }
    }
  }
}
</script>

<style scoped lang="scss"></style>
